<template>
  <!-- 只能有一个div根标签 -->
  <div>
    <template>
      <div class="merchantList">
        <!-- 头部数据筛选区域 -->
        <div class="card-container">
          <div class="card-title">数据筛选</div>
          <div class="card-content">
            <a-form>
              <a-row>
                <a-col class="search-item" :span="6">
                  <a-form-item
                    label="区域"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 19 }"
                  >
                    <a-cascader
                      v-model="areaContain"
                      :options="options"
                      :load-data="loadData"
                      :field-names="{
                        label: 'name',
                        value: 'id',
                        children: 'children'
                      }"
                      placeholder="省市区"
                      change-on-select
                      @change="onAreaChange"
                    />
                  </a-form-item>
                </a-col>
                <a-col class="search-item" :span="6">
                  <a-form-item
                    label="循环商店名称"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 19 }"
                  >
                    <a-input
                      v-model="storeName"
                      allow-clear
                      placeholder="请填写循环商店名称"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col class="search-item" align="right">
                  <a-form-item>
                    <a-button type="primary" class="mr8" @click="toSearch">
                      查询
                    </a-button>
                    <a-button @click="resetTable"> 重置 </a-button>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>
          </div>
        </div>
        <!-- 数量展示 -->
        <div class="delivery-data">
          <div
            class="list"
            style="text-align:center; display:flex;justify-content: space-around"
          >
            <div class="item">
              <div class="item-r">
                <span style="fontSize:20px">循环商店数量:</span>
                <span style="fontSize:22px; fontWeight:bold">{{
                  PostHouseCountInfo.postHouseStore
                }}</span>
              </div>
              <div class="solid"></div>
            </div>
            <div class="item">
              <div class="item-r">
                <span style="fontSize:20px">回收点数量: </span>
                <span style="fontSize:22px; fontWeight:bold">{{
                  PostHouseCountInfo.postHouse
                }}</span>
              </div>
              <div class="solid"></div>
            </div>
            <div class="item">
              <div class="item-r">
                <span style="fontSize:20px">回收人员数量: </span>
                <span style="fontSize:22px; fontWeight:bold">{{PostHouseCountInfo.recycleUser}}</span>
              </div>
              <div class="solid"></div>
            </div>
          </div>
        </div>
        <!-- 列表区域 -->
        <div class="bottomContent">
          <div class="mb20">
            <a-row>
              <a-col :span="12" class="title"> 循环商店列表 </a-col>
              <a-col :span="12" align="right">
                <a-button type="primary" @click="add()">
                  添加循环商店
                </a-button>
              </a-col>
            </a-row>
          </div>
          <a-table
            :columns="columns"
            表头
            :data-source="tableData"
            :pagination="pagination"
            :row-key="record => record.id"
            :loading="loading"
            class="table-content"
            @change="handleTableChange"
          >
            <template slot="businessTime" slot-scope="record">
              {{ record.beginBusinessTime }} - {{ record.endBusinessTime }}
            </template>
            <template slot="operate" slot-scope="text">
              <a-button type="link" size="small" @click="view(text)">
                查看
              </a-button>
              <a-button type="link" size="small" @click="edit(text)">
                编辑
              </a-button>
              <a-button type="link" size="small" @click="del(text)">
                删除
              </a-button>
            </template>
          </a-table>
        </div>
        <a-modal
          v-model="deleteVisible"
          ok-text="确定"
          cancel-text="取消"
          class="comModal"
          @ok="deleteModal"
        >
          <div class="dlContent">
            <icon-font type="iconShape" class="dlIcon"></icon-font>
            <span class="dlTitle">提示</span>
            <div class="dlMain">是否确定删除此商店？</div>
          </div>
        </a-modal>
      </div>
    </template>
  </div>
</template>
<script>
import {
  delPostHouseStore,
  findPostHouseStoreList,
  findPostHouseCountInfo
} from "@/api/postManagement";
import {
  iconFontComponent,
  getArea,
  getEstate
} from "@/components/mixins/mixins.js";

const columns = [
  {
    title: "循环商店名称",
    key: "storeName",
    dataIndex: "storeName"
  },
  {
    title: "循环商店地址",
    key: "address",
    dataIndex: "address"
  },
  {
    title: "循环商店类型",
    key: "storeType",
    dataIndex: "storeType"
  },
  {
    title: "营业时间",
    key: "businessTime",
    scopedSlots: { customRender: "businessTime" }
  },
  {
    title: "店长",
    key: "storeManager",
    dataIndex: "storeManager"
  },
  {
    title: "联系电话",
    key: "mobile",
    dataIndex: "mobile"
  },

  {
    title: "操作",
    key: "operate",
    width: 150,
    fixed: "right",
    scopedSlots: { customRender: "operate" }
  }
];
export default {
  name: "StoreManagement",
  mixins: [iconFontComponent, getArea, getEstate],
  data() {
    return {
      // formData: {
      //   storeName: ''
      // },
      PostHouseCountInfo: {},
      areaContain: [],
      areaNames: [],
      columns,
      tableData: [],
      loading: false,
      pagination: {
        current: 1,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => "共" + total + "条记录",
        pageSizeOptions: ["10", "20", "30", "40"],
        defaultPageSize: 10,
        pageSize: 10,
        total: 0
      },
      deleteVisible: false,
      delId: "",
      estate: "",
      storeName: "",
      estateList: [],
      params: {
        name: "",
        storeManager: "",
        province: "",
        city: "",
        areaId: "",
        estateId: "",
        page: "",
        pageSize: "",
        postHouseIds: ""
      },
      totalCount:0
    };
  },
  beforeRouteEnter(to, from, next) {
    if (from.name === "merchantDetails") {
      next(vm => {
        vm.load();
      });
    } else {
      next();
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "merchantDetails") {
      from.meta.keepAlive = true;
      next();
    } else {
      from.meta.keepAlive = false;
      next();
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.getArea("", 2, null, true);
      this.getEstate();
      this.findPostHouseStoreList();
      // this.getManager(params)
      this.findPostHouseCountInfo();
    },
    // },

    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      this.getArea(targetOption.id, targetOption.layer + 1, targetOption, true);
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    // 获取回收点循环人员数量等
    findPostHouseCountInfo() {
      this.loading = true;
      findPostHouseCountInfo({
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        id: this.$route.query.id
      }).then(res => {
        this.loading = false;

        this.PostHouseCountInfo = res.result;
        // this.pagination.total = res.result.totalCount
      });
    },

    changeArea(value, obj) {
      this.estateList = [];
      this.estate = undefined;
      if (value.length < 4) {
        this.getEstate(value);
      } else if (value.length === 4) {
        this.getEstate(null, value[3]);
      }
    },
    // 获取循环商店列表信息
    findPostHouseStoreList() {

      this.params = {
        storeName: this.storeName,
        province: this.areaContain.length > 0 ? this.areaContain[0] : "",
        city: this.areaContain.length > 0 ? this.areaContain[1] : "",
        areaId: this.areaContain.length > 0 ? this.areaContain[2] : "",
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      };
      if (this.estate) {
        params.estateId = this.estate;
      }
      this.loading = true;

      findPostHouseStoreList(this.params)
        .then(res => {
          this.loading = false;
          this.tableData = res.result.list;
          this.pagination.total = res.result.totalCount
        })
        .catch(e => {
          this.$message.error("");
        });
    },
    handleTableChange(pagination, filters, sorter) {
      this.pagination.pageSize = pagination.pageSize;
      this.pagination.current = pagination.current;
      this.findPostHouseStoreList();
    },
    toSearch() {
      this.findPostHouseStoreList();
    },
    initData() {
      const params = {};
      // params.menuId = '7d021664be58415cb158ba35b2645d72'
      params.page = this.pagination.current;
      params.pageSize = this.pagination.pageSize;
      if (this.areaContain.length !== 0) {
        if (this.areaContain[0]) {
          params.province = this.areaContain[0];
        }
        if (this.areaContain[1]) {
          params.city = this.areaContain[1];
        }
        if (this.areaContain[2]) {
          params.areaId = this.areaContain[2];
        }
      }
      if (this.estate) {
        params.estateId = this.estate;
      }
      if (this.storeName) {
        params.title = this.storeName;
      }
      // if (this.creater) {
      //   params.createUser = this.creater
      // }
      this.findPostHouseStoreList(params);
    },

    resetTable() {
      this.areaContain = [];
      this.estate = undefined;
      this.storeName = "";
      // this.creater = ''
      const params = {};
      params.page = 1;
      params.pageSize = this.pagination.pageSize;
      this.findPostHouseStoreList();
    },
    onAreaChange(value, obj) {
      this.estateList = [];
      this.estate = undefined;
      if (value.length < 4) {
        this.getEstate(value);
      } else if (value.length === 4) {
        this.getEstate(null, value[3]);
      }
    },

    add(val) {
      this.$router.push({
        path: "/postManagement/addStore",
        query: { title: "添加", it: val }
      });
    },
    view(value) {
      this.$router.push({
        path: "/postManagement/addStore",
        query: { id: value.id, titless: "查看" }
      });
    },
    edit(value) {
      this.$router.push({
        path: "/postManagement/addStore",
        query: { id: value.id, title: "编辑" }
      });
    },
    del(value) {
      this.deleteVisible = true;
      this.delId = value.id;
    },
    deleteModal() {
      const params = {
        id: this.delId
      };

      delPostHouseStore(params).then(res => {
        this.$message.success(res.msg)
        this.deleteVisible = false
        this.findPostHouseStoreList()
        this.findPostHouseCountInfo()
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.merchantList {
  .w100 {
    width: 100%;
  }

  .mr8 {
    margin-right: 8px;
  }

  .bottomContent {
    background-color: #fff;
    padding: 16px 20px;

    .mb20 {
      margin-bottom: 20px;
    }
  }

  .title {
    color: #333;
    font-weight: 600;
    font-size: 16px;
  }

  .add-person {
    margin-right: 10px;
  }
}

.dlContent {
  .dlIcon {
    font-size: 30px;
  }

  .dlTitle {
    vertical-align: text-bottom;
    padding-left: 10px;
    font-size: 16px;
    color: #333;
    font-weight: 500;
  }

  .dlMain {
    position: absolute;
    top: 64px;
    left: 64px;
    color: #666;
    font-size: 14px;
  }
}

@import '~@/assets/css/common.styl';

.delivery-data {
  width: 100%;
  padding: 16px 20px;
  box-sizing: border-box;
  background-color: #fff;
  margin: 16px 0;

  // .list {
  //   width: 100%;
  //   display: flex;
  //   padding: 0 54px;
  //   box-sizing: border-box;
  //   justify-content: space-between;

    // .item {
    //   width: 24%;
    //   display: flex;
    //   // cursor pointer
    //   height: 90px;
    //   align-items: center;

    //   .item-r {
    //     padding-top: 20px;
    //     line-height: 16px;
    //     margin-left: 16px;
    //     font-size: 12px;
    //     color: #666666;
    //     width: 60%;

    //     p:last-child {
    //       font-size: 22px;
    //       color: #000;
    //       font-weight: 600;
    //     }
    //   }
    // }

  //   .solid {
  //     width: 1px;
  //     height: 58px;
  //     background-color: #F2F2F2;
  //   }
  // }
}
</style>
<style lang="stylus">
.merchantList {
  .ant-btn-sm {
    padding-left: 0;
    padding-right: 10px;
  }
}
</style>
